import { render } from "./BaseTableFields.vue?vue&type=template&id=48d8dbb2&scoped=true"
import script from "./BaseTableFields.vue?vue&type=script&lang=js"
export * from "./BaseTableFields.vue?vue&type=script&lang=js"

import "./BaseTableFields.vue?vue&type=style&index=0&id=48d8dbb2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d8dbb2"]])

export default __exports__